import { render } from "./NewsSelectOnePage.vue?vue&type=template&id=fa1745fe&scoped=true"
import script from "./NewsSelectOnePage.vue?vue&type=script&lang=js"
export * from "./NewsSelectOnePage.vue?vue&type=script&lang=js"

import "./NewsSelectOnePage.vue?vue&type=style&index=0&id=fa1745fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1745fe"]])

export default __exports__